export default [
  {
    header: 'Полоски',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Список полосок',
    route: 'strips-list',
    icon: 'GridIcon',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Создать полоску',
    route: 'strip-builder-create',
    icon: 'PlusSquareIcon',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Импорт архива',
    route: 'strip-import-archive',
    icon: 'UploadIcon',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Импорт SIQ',
    route: 'strip-import-siq',
    icon: 'FileTextIcon',
    resource: 'strips',
    action: 'view',
  },
]
